import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseAccessPolicy from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAccessPolicy';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import {ObjectTypes} from '../../../../api/consts';


const pageSchema = GatewayGetSchema.pages.accessPolicy;
const pageId = pageSchema.pageId;

/**
 * @param {Object} params
 * @param {import('../../../../api/DBSchema/Gateway').Gateway} params.gatewayObject
 */
function PlanAccessPolicy({
                              planObject,
                              setPlanData,
                              appiData,
                              uoTableData,
                              zonesData,
                              setUoTableDataValue,
                              setAppiDataValue
                          }) {
    const pageData = planObject[pageId];
    const planName = planObject[PlanGetSchema.id];

    return (
        <BaseAccessPolicy
            pageData={pageData}
            setObjectData={setPlanData}
            baseObjectName={planName}
            objectType={ObjectTypes.PLAN}
            appiData={appiData}
            uoTableData={uoTableData}
            zonesData={zonesData}
            setUoTableDataValue={setUoTableDataValue}
            setAppiDataValue={setAppiDataValue}

        />
    );
}

export default PlanAccessPolicy;